webpackJsonp([7],{

/***/ 3157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_base_buttons_BackButton__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_forum_mixin__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_healthy_community_HealthyCommunityVerticalCard__ = __webpack_require__(3642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_healthyCommunitySections__ = __webpack_require__(291);
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'healthy-community',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_forum_mixin__["a" /* default */]],
  components: {
    HealthyCommunityVerticalCard: __WEBPACK_IMPORTED_MODULE_2__components_views_healthy_community_HealthyCommunityVerticalCard__["a" /* default */],
    BackBtn: __WEBPACK_IMPORTED_MODULE_0__components_base_buttons_BackButton__["a" /* default */]
  },
  data: function data() {
    return {
      cardsSource: [{
        title: this.$t('whoIn'),
        img: '/static-appopensalud/img/healthy-community/who-in-simplified.svg',
        description: '' + this.$t('whoInSectionDescription'),
        path: 'quienseapunta',
        sectionId: __WEBPACK_IMPORTED_MODULE_3__constants_healthyCommunitySections__["d" /* WHO_IN_HEALTH_COMMUNITY_SECTION */],
        onlySubscribers: true
      },
      /* {
        title: this.$t('healthyInformation'),
        img: '/static-appopensalud/img/healthy-community/healthy-information.svg',
        description: `${this.$t('healthyInformationSectionDescription')}`,
        path: 'informacionsalud',
        sectionId: HEALTHY_INFORMATION_HEALTH_COMMUNITY_SECTION
      }, */
      {
        title: this.$t('patientsLikeYou'),
        img: '/static-appopensalud/img/healthy-community/patients-like-you.svg',
        description: this.$t('forumSectionDescription'),
        path: 'pacientescomotu',
        sectionId: __WEBPACK_IMPORTED_MODULE_3__constants_healthyCommunitySections__["a" /* FORUM_HEALTH_COMMUNITY_SECTION */]
      }]
    };
  },
  created: function created() {
    this.$store.state.forum.hideSearcher = true;
    this.$store.state.forum.entriesPageNumber = 0;
  },

  computed: {
    cards: function cards() {
      return this.cardsSource;
    }
  }
});

/***/ }),

/***/ 3158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_forum_mixin__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_ui_BaseCard__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_buttons_BaseButton__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_healthyCommunitySections__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'healthy-community-vertical-card',
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_forum_mixin__["a" /* default */]],
    components: {
        BaseCard: __WEBPACK_IMPORTED_MODULE_1__components_base_ui_BaseCard__["default"],
        BaseButton: __WEBPACK_IMPORTED_MODULE_2__components_base_buttons_BaseButton__["default"],
        BBadge: __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__["b" /* BBadge */]
    },
    props: {
        path: String,
        soonLabel: Boolean,
        sectionId: String,
        img: String,
        title: String,
        description: String,
        onlySubscribers: Boolean
    },
    data: function data() {
        return {
            blinkSoonLabelActive: false
        };
    },
    created: function created() {
        this.$store.state.forum.sectionId = null;
    },

    computed: {
        blockEnabled: function blockEnabled() {
            return this.onlySubscribers ? this.$store.getters['session/healthyCommunityActive'] : true;
        }
    },
    methods: {
        goToPath: function goToPath(sectionId) {
            if (!this.$store.getters['session/isLogged'] && (sectionId === __WEBPACK_IMPORTED_MODULE_3__constants_healthyCommunitySections__["b" /* HEALTHY_INFORMATION_HEALTH_COMMUNITY_SECTION */] || sectionId === __WEBPACK_IMPORTED_MODULE_3__constants_healthyCommunitySections__["d" /* WHO_IN_HEALTH_COMMUNITY_SECTION */])) {
                this.logIn(this.getHealthyCommunityPathUrl(this.path));
                return;
            }
            this.$router.push(this.getHealthyCommunityPathUrl(this.path));
        },
        getPendingPushNotificationsMessage: function getPendingPushNotificationsMessage(sectionId) {
            var numberNotifications = this.$store.state.forum.userBasicInfo.pushNotificationsSectionId.filter(function (x) {
                return x === sectionId;
            }).length;
            if (numberNotifications === 1) {
                return this.$t('newPushNotifications', { plural: '', numberNotifications: numberNotifications });
            } else if (numberNotifications > 1) {
                return this.$t('newPushNotifications', { plural: 's', numberNotifications: numberNotifications });
            }
        },
        showPendingNotificationBySection: function showPendingNotificationBySection(sectionId) {
            this.showPushNotifications(sectionId);
        },
        goSection: function goSection(sectionId) {
            this.pushNotificationsReaded(sectionId);
            this.$router.push(this.getHealthyCommunityPathUrl(this.getForumPathBySectionId(sectionId)));
        },
        showPendingPushNotificationsInLanding: function showPendingPushNotificationsInLanding(sectionId) {
            return this.$store.state.forum.userBasicInfo.pushNotificationsSectionId.filter(function (x) {
                return x === sectionId;
            }).length > 0;
        },
        highlightSoonLabel: function highlightSoonLabel() {
            var _this = this;

            this.blinkSoonLabelActive = true;
            setTimeout(function () {
                _this.blinkSoonLabelActive = false;
            }, 4000);
        },
        click: function click() {
            if (this.soonLabel) {
                this.highlightSoonLabel();
            } else if (!this.blockEnabled) {
                this.$store.dispatch('showSharedDialog', {
                    content: this.$t('only-subscriptors-warning'),
                    okBtnText: this.$t('dialog.ok-button'),
                    size: 'sm'
                });
            } else {
                this.goToPath(this.sectionId);
            }
        }
    }
});

/***/ }),

/***/ 3640:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3641);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("6d7cc289", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-18980053\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HealthyCommunity.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-18980053\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HealthyCommunity.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3641:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n.healthyCommunity{min-height:70dvh\n}\n.healthy-community-title{text-align:center\n}\n.btn-go-openhealth{display:block;margin-left:5rem\n}\n@media only screen and (max-width: 575px){\n.btn-go-openhealth{margin-left:1rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.btn-go-openhealth{margin-left:1rem\n}\n}\n", ""]);

// exports


/***/ }),

/***/ 3642:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HealthyCommunityVerticalCard_vue__ = __webpack_require__(3158);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ea826ce_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HealthyCommunityVerticalCard_vue__ = __webpack_require__(3645);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3643)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HealthyCommunityVerticalCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ea826ce_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HealthyCommunityVerticalCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/healthy-community/HealthyCommunityVerticalCard.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7ea826ce", Component.options)
  } else {
    hotAPI.reload("data-v-7ea826ce", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3643:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3644);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("58042e24", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ea826ce\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HealthyCommunityVerticalCard.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ea826ce\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HealthyCommunityVerticalCard.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3644:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n.healthyCommunityMainBlock{max-width:570px\n}\n@media only screen and (max-width: 575px){\n.healthyCommunityMainBlock{height:100% !important\n}\n}\n.healthyCommunityBlockHeight{text-align:center !important;margin:2%;min-height:301px\n}\n.healthyCommunityImageSize{margin-bottom:1rem;width:100%\n}\n.healthyCommunityTitle{color:#3238C4 !important\n}\n@media only screen and (min-width: 1003px) and (max-width: 1586px){\n.healthyCommunityTitle{height:51px !important\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1002px){\n.healthyCommunityTitle{height:81px !important\n}\n}\n.btnAccessHealthyCommunity{margin-bottom:0 !important;padding:0.5rem 1.5rem !important\n}\n.btnReadNotificationsHealthyCommunity{font-size:11px;padding:0.5rem 1.5rem\n}\n.description-block-healthy-community{margin-top:0;margin-bottom:0\n}\n@media only screen and (min-width: 1621px){\n.description-block-healthy-community{min-height:45px\n}\n}\n@media only screen and (min-width: 1334px) and (max-width: 1620px){\n.description-block-healthy-community{min-height:67.5px\n}\n}\n@media only screen and (min-width: 1140px) and (max-width: 1333px){\n.description-block-healthy-community{min-height:90px\n}\n}\n.neu-card-title{color:#3238C4;font-weight:bold;font-size:1.25rem;margin:0\n}\n@media only screen and (min-width: 1200px){\n.healthyCommunityMainBlock .neu-card{padding-left:3.2rem !important;padding-right:3.2rem !important\n}\n}\n.soon-label-healthy-community{position:relative;margin-top:0 !important\n}\n", ""]);

// exports


/***/ }),

/***/ 3645:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-col",
    {
      staticClass: "healthyCommunityMainBlock my-3 px-2",
      attrs: { cols: "12", xl: "4" },
      on: { click: _vm.click }
    },
    [
      _c(
        "base-card",
        {
          staticClass: "healthyCommunityBlockHeight pointer",
          attrs: { titleClass: "healthyCommunityTitle" }
        },
        [
          _c("base-icon", {
            class: {
              "d-inline-block": _vm.$store.state.isMobile,
              "mr-2": _vm.$store.state.isMobile
            },
            attrs: {
              src: _vm.img,
              alt: "",
              height: _vm.$store.state.isMobile ? "30" : "42",
              width: _vm.$store.state.isMobile ? "30" : "42",
              color: "blue"
            }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "neu-card-title my-3" }, [
            _vm._v(_vm._s(_vm.title))
          ]),
          _vm._v(" "),
          _c("p", {
            staticClass: "description-block-healthy-community",
            domProps: { innerHTML: _vm._s(_vm.description) }
          }),
          _vm._v(" "),
          _vm.blockEnabled
            ? _c(
                "div",
                [
                  _vm.showPendingPushNotificationsInLanding(_vm.sectionId) &&
                  !_vm.soonLabel
                    ? _c(
                        "p",
                        {
                          staticClass: "my-3",
                          staticStyle: { "margin-bottom": "0 !important" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.goSection(_vm.sectionId)
                            }
                          }
                        },
                        [
                          _c(
                            "base-button",
                            {
                              staticClass:
                                "btnReadNotificationsHealthyCommunity",
                              attrs: { white: "" }
                            },
                            [
                              _c("b-icon-bell", { staticClass: "pointer" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.getPendingPushNotificationsMessage(
                                      _vm.sectionId
                                    )
                                  )
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.showPendingPushNotificationsInLanding(_vm.sectionId) &&
                  !_vm.soonLabel
                    ? _c(
                        "base-button",
                        {
                          staticClass: "btnAccessHealthyCommunity my-3",
                          attrs: { white: "" }
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.$t("accessBtn")))])]
                      )
                    : _vm._e()
                ],
                1
              )
            : _c(
                "div",
                [
                  _c(
                    "b-badge",
                    { staticClass: "mt-3", attrs: { variant: "info" } },
                    [_vm._v(_vm._s(_vm.$t("only-subscriptors")))]
                  )
                ],
                1
              ),
          _vm._v(" "),
          _vm.soonLabel
            ? _c(
                "p",
                { staticStyle: { "margin-bottom": "0" } },
                [
                  _c(
                    "b-badge",
                    {
                      staticClass: "mt-3 soon-label-healthy-community",
                      class: { blink: _vm.blinkSoonLabelActive },
                      attrs: { variant: "primary" }
                    },
                    [_vm._v(_vm._s(_vm.$t("soon-label")))]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ea826ce", esExports)
  }
}

/***/ }),

/***/ 3646:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "healthyCommunity pb-5 ctm-container" },
    [
      _c("h1", { staticClass: "healthy-community-title my-3" }, [
        _vm._v(_vm._s(_vm.$t("healthyCommunityTitle")))
      ]),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "d-flex justify-content-center" },
        _vm._l(_vm.cards, function(item) {
          return _c("healthy-community-vertical-card", {
            key: item.title,
            attrs: {
              path: item.path,
              soonLabel: item.soonLabel,
              sectionId: item.sectionId,
              img: item.img,
              title: item.title,
              description: item.description,
              onlySubscribers: item.onlySubscribers
            }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18980053", esExports)
  }
}

/***/ }),

/***/ 540:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HealthyCommunity_vue__ = __webpack_require__(3157);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18980053_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HealthyCommunity_vue__ = __webpack_require__(3646);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3640)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HealthyCommunity_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18980053_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HealthyCommunity_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/healthy-community/HealthyCommunity.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-18980053", Component.options)
  } else {
    hotAPI.reload("data-v-18980053", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/7.93cc8cea294675401717.js